import { useCallback } from 'react';
import { useAuth } from '@/services/auth';
import { isFlexPlan } from '@/services/auth/plan-slugs';
import type { AddonPurchaseData, AddonPurchaseResult } from '../components/addon-purchase-panel';
import { addonPurchaseRequest } from '../components/addon-purchase-request';

export type AddonPurchase = {
  canPurchase: boolean;
  openAddon: (data: AddonPurchaseData) => Promise<AddonPurchaseResult | null>;
};

export function useAddonPurchase(): AddonPurchase {
  const { account } = useAuth();
  const canPurchase = isFlexPlan(account);

  const openAddon = useCallback(
    async (data: AddonPurchaseData) => {
      if (!canPurchase) return null;
      const result = await addonPurchaseRequest.request(data);
      return result.reason === 'confirm' ? (result.data ?? null) : null;
    },
    [canPurchase],
  );

  return { canPurchase, openAddon };
}
